import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import NutSeedButtersProduct from 'models/NutSeedButtersProduct'
import NutSeedButtersNutrition from './NutSeedButtersNutrition'
import NutSeedButtersPackage from './NutSeedButtersPackage'

const productOptions = {
  nutritionInfo: <NutSeedButtersNutrition />,
  packagingInfo: <NutSeedButtersPackage />,
  productTitle: 'Brand Specific Nut and Seed Butters',
  model: NutSeedButtersProduct,
  validCategories: ['00'],
  validSubCategories: ['003'],
}

const NutSeedButters = () => <ProductForm product={productOptions} />

export default NutSeedButters
